import { NgModule } from '@angular/core';
import { MsTableComponent } from './ms-table.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';
import { MsButtonModule } from '../ms-button/ms-button.module';
import { MsInputSwitchModule } from '../ms-input-switch/ms-input-switch.module';

@NgModule({
	declarations: [MsTableComponent],
	imports: [SharedLibsModule, MsButtonModule, MsInputSwitchModule],
	exports: [MsTableComponent],
	providers: [],
})
export class MsTableModule {}
